import {
  ChangeDetectorRef,
  Component,
  ComponentRef, Injector,
  OnInit, TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {NbComponentStatus, NbDialogRef} from "@nebular/theme";
import {Globals} from "../../shared/Globals";
import {SubscribedComponent} from "../../subscribed.component";

@Component({
    selector: 'bst-popup-dialog',
    templateUrl: './popup-dialog.component.html',
    styleUrls: ['./popup-dialog.component.scss'],
    standalone: false
})
export class PopupDialogComponent<T extends SubscribedComponent> implements OnInit {

  public Globals = Globals;
  public title = null;
  public subtitle = null;
  public footer: TemplateRef<any> = null;

  @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;
  private componentRef: ComponentRef<T>;
  public componentContext: Partial<T> = null;
  public comp = null;
  public willclose?: (popup: PopupDialogComponent<T>) => boolean|Promise<boolean> = null;


  constructor(protected ref: NbDialogRef<PopupDialogComponent<T>>,
              private injector: Injector,
              private detector: ChangeDetectorRef,
) {

  }

  /**
   *  Must override
   * @protected
   */
  protected component(): any{
    if(!this.comp){
      throw new Error("Component not assigned in popup");
    }
    return this.comp;
  }

  protected ngOnInitComponent(): void{

  }

  ngOnInit(): void {
    this.componentRef = this.container.createComponent<T>(this.component());
    if(this.componentContext){
      Object.assign(this.componentRef.instance, {...this.componentContext});
    }
    this.ngOnInitComponent();
    this.detector.detectChanges();
  }

  public get instance(){
    return this.componentRef && this.componentRef.instance ? this.componentRef.instance : null;
  }

  done(result: any = null) {
    if(this.willclose){
      const res = this.willclose(this);
      if(res instanceof Promise){
        res.then((will: boolean) => {
          if(will) {
            this.ref.close(result);
          }
        });
      }
      else if(res){
        this.ref.close(result);
      }
    }
    else {
      this.ref.close(result);
    }
  }
}
